import React from 'react'
import Card from 'react-bootstrap/Card';
import PCR from "../../../assets/icons/Platform/PCR_tests.svg";
import {iconHelper} from "../../../utils/utils";
import { getTestNameFromType } from "../../../utils";
import { useMediaQuery } from "react-responsive";
import DesktopView from './DesktopView';
import MobileView from './MobileView';
import clockIcon from "../../../assets/images/clock-icon-1.svg";

const ActionRequiredCard = (test) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    

    return (
        <Card className={`action-required-card ${isMobile ? "" : "mb-4"}`}>
            {isMobile ? <MobileView test={test} clockIcon={clockIcon}/> : <DesktopView test={test} clockIcon={clockIcon}/>}
        </Card>
    )
}

export default ActionRequiredCard